import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from 'react-router-dom';
import apiClient from "../../../api/apiClient";
import { BackArrowIcon } from "../../../utils/FontIcon";
import { Form, Button, Row, Col, Table, Badge, Alert, Spinner } from "react-bootstrap";
import { Input, AlertMassage, PopupModel } from "../../shared";
import { isNotEmpty, isValidMobileNumber, isValidNumber, hasSpecificLength, isValidEmail } from "../../../utils/validation"


export default function CreatePlan({ levels }) {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    trainingmode: '',
    planstatus: '',
    traininstatus: '',
    title: '',
    description: '',
    linkcourse: '',
    startdatetime: '',
    enddatetime: '',
    ragistrationendtime: '',
    capacity: '',
    venuename: '',
    venuaddress1: '',
    venuaddress2: '',
    venustate: '',
    venudistrict: '',
    venucity: '',
    trainername: '',
    trainermobile: '',
    traineremail: '',
    coordinatorname: '',
    cordinatormobile: '',
    cordinatoremail: '',
    stakeHolderList: []
  })
  const [errors, setErrors] = useState({});
  const [stakeHolderinformation, setStakeHolderinformation] = useState({
    holdertype: '',
    organisation: '',
    role: '',
    name: '',
    email: '',
    mobile: ''
  });
  const [errorStakeholder, setErrorStakeholder] = useState({});
  const [popupData, setPopupData] = useState({
    show: false,
    type: '',
    title: '',
  });
  const [planStatus, setPlanStatus] = useState([{ value: '0001', label: 'Planned' },
  { value: '0002', label: 'Unplanned' }]);
  const [traningStatus, setTraningStatus] = useState([{ value: '0001', label: 'Scheduled' },
  { value: '0002', label: 'Unscheduled' }]);
  const [state, setState] = useState([{ value: '0001', label: 'General Courses (open for all)' },
  { value: '0002', label: 'Policy & Implementation (Government Officials)' },
  { value: '0003', label: 'Banking & Financial Institutions (Banking officials)' },]);
  const [district, setDistrict] = useState([{ value: '0001', label: 'General Courses (open for all)' },
  { value: '0002', label: 'Policy & Implementation (Government Officials)' },
  { value: '0003', label: 'Banking & Financial Institutions (Banking officials)' },]);
  const [city, setCity] = useState([{ value: '0001', label: 'General Courses (open for all)' },
  { value: '0002', label: 'Policy & Implementation (Government Officials)' },
  { value: '0003', label: 'Banking & Financial Institutions (Banking officials)' },]);

  const [stakeHolderType, setStakeHolderType] = useState([{ value: '0001', label: 'General Courses (open for all)' },
  { value: '0002', label: 'Policy & Implementation (Government Officials)' },
  { value: '0003', label: 'Banking & Financial Institutions (Banking officials)' },]);
  const [organization, setOrganization] = useState([{ value: '0001', label: 'Planned' },
  { value: '0002', label: 'Unplanned' }]);
  const [role, setRole] = useState([{ value: '0001', label: 'Scheduled' },
  { value: '0002', label: 'Unscheduled' }]);

  const handelChange = useCallback((e) => {
    const { name, value, files } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
    // if (files) {
    //   const file = files[0];
    //   const basicMeta = {
    //     name: file.name,
    //     size: (file.size / 1024 / 1024).toFixed(2),
    //     type: file.type,
    //     lastModified: new Date(file.lastModified).toLocaleString(),
    //   };
    //   if (file.type.startsWith('image/')) {
    //     extractImageMetadata(file, basicMeta);
    //   }
    // }

    setErrors((prev) => ({ ...prev, [(name=='venuaddress1' || name=='venuaddress2')?'venuaddress':name ]: undefined }));
  }, []);
  const handelChangestakeholder = useCallback((e) => {
    const { name, value } = e.target;
    setStakeHolderinformation((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrorStakeholder((prev) => ({ ...prev, [name]: undefined }));
  }, []);
  const validateform = () => {
    const { trainingmode, planstatus, traininstatus, title, description, linkcourse, startdatetime, enddatetime, ragistrationendtime, capacity, venuename, venuaddress1, venuaddress2, venustate, venudistrict, venucity, trainername, trainermobile, traineremail, coordinatorname, cordinatormobile, cordinatoremail, stakeHolderList } = form
    const newErrors = {};
    if (!isNotEmpty(trainingmode)) newErrors.trainingmode = "Training mode is required";
    if (!isNotEmpty(planstatus)) newErrors.planstatus = "Plan status is required";
    if (!isNotEmpty(traininstatus)) newErrors.traininstatus = "training status is required";
    if (!isNotEmpty(title)) newErrors.title = "Title is required";
    if (!isNotEmpty(description)) newErrors.description = "Description is required";
    if (!isNotEmpty(linkcourse)) newErrors.linkcourse = "Course is required";
    if (!isNotEmpty(startdatetime)) newErrors.startdatetime = "Start date and time is required";
    if (!isNotEmpty(enddatetime)) newErrors.enddatetime = "End date and time is required";
    if (!isNotEmpty(ragistrationendtime)) newErrors.ragistrationendtime = "Registration end date and time is required";
    if (!isNotEmpty(capacity)) newErrors.capacity = "Capacity is required";
    if (!isNotEmpty(venuename)) newErrors.venuename = "Venue Name  is required";
    if (!isNotEmpty(venuaddress1) && !isNotEmpty(venuaddress2)) newErrors.venuaddress = "Vanue address is required";
    if (!isNotEmpty(venustate)) newErrors.venustate = "Venue state is required";
    if (!isNotEmpty(venudistrict)) newErrors.venudistrict = "Venue district is required";
    if (!isNotEmpty(venucity)) newErrors.venucity = "Venue city is required";
    if (!isNotEmpty(trainername)) newErrors.trainername = "Trainer name is required";
    if (!isNotEmpty(trainermobile)) newErrors.trainermobile = "Trainer mobile number is required";
    else if (!isValidNumber(trainermobile)) newErrors.trainermobile = "Mobile Number is not valid";
    else if (!isValidMobileNumber(trainermobile)) newErrors.trainermobile = "Mobile Number should start with 6,7,8 or 9";
    else if (!hasSpecificLength(trainermobile, 10)) newErrors.trainermobile = "Mobile Number should be 10 digits";
    if (!isNotEmpty(traineremail)) newErrors.traineremail = "Email ID is required";
    else if (!isValidEmail(traineremail)) newErrors.traineremail = "Email ID is not Valid";

    if (!isNotEmpty(coordinatorname)) newErrors.coordinatorname = "Coordinator name is required";
    if (!isNotEmpty(cordinatormobile)) newErrors.cordinatormobile = "Coordinator mobile number is required";
    else if (!isValidNumber(cordinatormobile)) newErrors.cordinatormobile = "Mobile Number is not valid";
    else if (!isValidMobileNumber(cordinatormobile)) newErrors.cordinatormobile = "Mobile Number should start with 6,7,8 or 9";
    else if (!hasSpecificLength(cordinatormobile, 10)) newErrors.cordinatormobile = "Mobile Number should be 10 digits";
    if (!isNotEmpty(cordinatoremail)) newErrors.cordinatoremail = "Cordinator Email ID is required";
    else if (!isValidEmail(cordinatoremail)) newErrors.cordinatoremail = "Email ID is not Valid";
    if (!stakeHolderList.length) newErrors.stakeHolderList = "Stakeholder should not be empty";
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return false;
    } else {
      setErrors({});
      return true;
    }
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validateform();
    if (!validationErrors) {
      return;
    }
    console.log('form is validate for submit')
  };
  const validateStakeHolderForm = () => {
    const { holdertype, organisation, role, name, email, mobile } = stakeHolderinformation
    const newErrors = {};
    if (!isNotEmpty(holdertype)) newErrors.holdertype = "Stakeholder type is required";
    if (!isNotEmpty(organisation)) newErrors.organisation = "Organization is required";
    if (!isNotEmpty(role)) newErrors.role = "Role is required";
    if (!isNotEmpty(name)) newErrors.name = "Name is required";
    if (!isNotEmpty(mobile)) newErrors.mobile = "Mobile number is required";
    else if (!isValidNumber(mobile)) newErrors.mobile = "Mobile Number is not valid";
    else if (!isValidMobileNumber(mobile)) newErrors.mobile = "Mobile Number should start with 6,7,8 or 9";
    else if (!hasSpecificLength(mobile, 10)) newErrors.mobile = "Mobile Number should be 10 digits";
    if (!isNotEmpty(email)) newErrors.email = "Email ID is required";
    else if (!isValidEmail(email)) newErrors.email = "Email ID is not Valid";

    if (Object.keys(newErrors).length > 0) {
      setErrorStakeholder(newErrors);
      return false;
    } else {
      setErrorStakeholder({});
      return true;
    }
  };
  const handleAddStakeHolder = (e) => {
    e.preventDefault();
    if (validateStakeHolderForm()) {
      setForm((prev) => ({
        ...prev,
        'stakeHolderList': [
          ...prev.stakeHolderList,
          { ...stakeHolderinformation }
        ],
      }));
      handleCloseModal();
    }
  }
  const handelGotoDashboard = () => {
    navigate('/home');
  }
  const handelAddStakeholder = (e) => {
    setPopupData({
      show: true,
      type: 'addstakeholder',
      title: 'Stakeholder Summary',
    })
  }
  const resetForm = (e) => {
    setForm({
      trainingmode: '',
      planstatus: '',
      traininstatus: '',
      title: '',
      description: '',
      linkcourse: '',
      startdatetime: '',
      enddatetime: '',
      ragistrationendtime: '',
      capacity: '',
      venuename: '',
      venuaddress1: '',
      venuaddress2: '',
      venustate: '',
      venudistrict: '',
      venucity: '',
      trainername: '',
      trainermobile: '',
      traineremail: '',
      coordinatorname: '',
      cordinatormobile: '',
      cordinatoremail: '',
      stakeHolderList: []
    })
    resetStakeHolder();
  }
  const resetStakeHolder = () => {
    setStakeHolderinformation({
      holdertype: '',
      organisation: '',
      role: '',
      name: '',
      email: '',
      mobile: ''
    })
  }
  const handleCloseModal = () => {
    setPopupData({
      show: false,
      type: '',
      title: '',
    })
    resetStakeHolder();
  }

  return (
    <Col lg={12} className="add-video-bg" >
      <Row>
        <Col xs={12} lg={10} md={8}>
          <h4 className="mb-0 fw-bold">Create Planing</h4>
          <div className="mb-2 ms-1 small fw-semibold text-secondary">(Add new plan)</div>
        </Col>
        <Col xs={12} lg={2} md={4} className="text-end">
          <Button variant="outline-dark" onClick={handelGotoDashboard} title="Go to dashboard"><BackArrowIcon /> Go to dashboard</Button>
        </Col>
      </Row>
      <Row>
        <div className="add-video-container">
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col lg={8} md={12} style={{ borderRight: "1px solid #dee2e6", paddingRight: '1.25rem' }}>
                <h5 className="d-block mb-3 fw-bold">Traning Details</h5>
                <Row>
                  <Col md={6}>
                    <Input
                      label="Category"
                      type="select"
                      name="trainingmode"
                      value={form.trainingmode}
                      onChange={handelChange}
                      isInvalid={!!errors.trainingmode}
                      feedback={errors.trainingmode}
                      options={[
                        { value: '0001', label: 'General Courses (open for all)' },
                        { value: '0002', label: 'Policy & Implementation (Government Officials)' },
                        { value: '0003', label: 'Banking & Financial Institutions (Banking officials)' },
                      ]}
                      isMandetory={true}
                      inlineFeedback={true}
                    />
                  </Col>
                  <Col md={3}>
                    <Input
                      label="Plan status"
                      type="select"
                      name="planstatus"
                      value={form.planstatus}
                      onChange={handelChange}
                      isInvalid={!!errors.planstatus}
                      feedback={errors.planstatus}
                      options={planStatus}
                      isMandetory={true}
                      inlineFeedback={true}
                    />
                  </Col>
                  <Col md={3}>
                    <Input
                      label="Training status"
                      type="select"
                      name="traininstatus"
                      value={form.traininstatus}
                      onChange={handelChange}
                      isInvalid={!!errors.traininstatus}
                      feedback={errors.traininstatus}
                      options={traningStatus}
                      isMandetory={true}
                      inlineFeedback={true}
                    />
                  </Col>
                  <Col md={12}>
                    <Input
                      label="Title"
                      type="text"
                      isMandetory={true}
                      name="title"
                      value={form.title}
                      onChange={handelChange}
                      placeholder="enter title"
                      isInvalid={!!errors.title}
                      feedback={errors.title}
                      inlineFeedback={true}
                      maxLength={80}
                    />
                  </Col>
                  <Col xs={12}>
                    <Input
                      label="Description"
                      isMandetory={true}
                      name="description"
                      value={form.description}
                      onChange={handelChange}
                      placeholder="enter description"
                      isInvalid={!!errors.description}
                      feedback={errors.description}
                      as="textarea"
                      rows={3}
                      inlineFeedback={true}
                      // maxLength={500}
                    />
                  </Col>
                  <Col xs={12}>
                    <Input
                      label="Link Course"
                      type="search"
                      isMandetory={true}
                      name="linkcourse"
                      value={form.linkcourse}
                      onChange={handelChange}
                      placeholder=""
                      isInvalid={!!errors.linkcourse}
                      feedback={errors.linkcourse}
                      inlineFeedback={true}
                      maxLength={80}
                    />
                  </Col>
                  <Col md={6}>
                    <Input
                      label="Start Date & time"
                      type="datetime-local"
                      name="startdatetime"
                      value={form.startdatetime}
                      onChange={handelChange}
                      isInvalid={!!errors.startdatetime}
                      feedback={errors.startdatetime}
                      isMandetory={true}
                      inlineFeedback={true}
                    />
                  </Col>
                  <Col md={6}>
                    <Input
                      label="End Date & time"
                      type="datetime-local"
                      name="enddatetime"
                      value={form.enddatetime}
                      onChange={handelChange}
                      isInvalid={!!errors.enddatetime}
                      feedback={errors.enddatetime}
                      isMandetory={true}
                      inlineFeedback={true}
                    />
                  </Col>
                  <Col md={6}>
                    <Input
                      label="Registration Deadline"
                      type="datetime-local"
                      name="ragistrationendtime"
                      value={form.ragistrationendtime}
                      onChange={handelChange}
                      isInvalid={!!errors.ragistrationendtime}
                      feedback={errors.ragistrationendtime}
                      isMandetory={true}
                      inlineFeedback={true}
                    />
                  </Col>
                  <Col md={6}>
                    <Input
                      label="Capacity"
                      type="number"
                      isMandetory={true}
                      name="capacity"
                      value={form.capacity}
                      onChange={handelChange}
                      placeholder="enter capacity"
                      isInvalid={!!errors.capacity}
                      feedback={errors.capacity}
                      inlineFeedback={true}
                    />
                  </Col>
                </Row>
              </Col>
              <Col lg={4} md={12} style={{ paddingLeft: '1.25rem' }}>
                <h5 className="d-block mb-3 fw-bold">Venue Details</h5>
                <Row>
                  <Col sm={12}>
                    <Input
                      label="Name"
                      type="text"
                      isMandetory={true}
                      name="venuename"
                      value={form.venuename}
                      onChange={handelChange}
                      placeholder="enter venuename"
                      isInvalid={!!errors.venuename}
                      feedback={errors.venuename}
                      inlineFeedback={true}
                      maxLength={80}
                    />
                  </Col>
                  <Col sm={12}>
                    <Input
                      label="Address line 1"
                      type="text"
                      isMandetory={true}
                      name="venuaddress1"
                      value={form.venuaddress1}
                      onChange={handelChange}
                      placeholder="enter address 1"
                      isInvalid={!!errors.venuaddress}
                      feedback={errors.venuaddress}
                      inlineFeedback={true}
                    />
                  </Col>
                  <Col sm={12}>
                    <Input
                      label="Address line 2"
                      type="text"
                      isMandetory={false}
                      name="venuaddress2"
                      value={form.venuaddress2}
                      onChange={handelChange}
                      placeholder="enter address 2"
                      isInvalid={!!errors.venuaddress}
                      feedback={errors.venuaddress}
                      inlineFeedback={true}
                    />
                  </Col>
                  <Col md={12}>
                    <Input
                      label="State"
                      type="select"
                      name="venustate"
                      value={form.venustate}
                      onChange={handelChange}
                      isInvalid={!!errors.venustate}
                      feedback={errors.venustate}
                      options={state}
                      isMandetory={true}
                      inlineFeedback={true}
                    />
                  </Col>
                  <Col md={12}>
                    <Input
                      label="District"
                      type="select"
                      name="venudistrict"
                      value={form.venudistrict}
                      onChange={handelChange}
                      isInvalid={!!errors.venudistrict}
                      feedback={errors.venudistrict}
                      options={district}
                      isMandetory={true}
                      inlineFeedback={true}
                    />
                  </Col>
                  <Col md={12}>
                    <Input
                      label="City"
                      type="select"
                      name="venucity"
                      value={form.venucity}
                      onChange={handelChange}
                      isInvalid={!!errors.venucity}
                      feedback={errors.venucity}
                      options={city}
                      isMandetory={true}
                      inlineFeedback={true}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row style={{ borderTop: "1px solid #dee2e6", marginTop: '1rem', paddingTop: '0.5rem' }}>
              <Col md={12}>
                <h5 className="d-block mb-1 fw-bold">Session information</h5>
                <h6 className="d-block mb-3 ">Trainer</h6>
              </Col>
              <Col md={4}>
                <Input
                  label="Name"
                  type="text"
                  isMandetory={true}
                  name="trainername"
                  value={form.trainername}
                  onChange={handelChange}
                  placeholder="enter trainername"
                  isInvalid={!!errors.trainername}
                  feedback={errors.trainername}
                  inlineFeedback={true}
                  maxLength={80}
                />
              </Col>
              <Col md={4}>
                <Input
                  label="Mobile No."
                  type="text"
                  isMandetory={true}
                  name="trainermobile"
                  value={form.trainermobile}
                  onChange={handelChange}
                  placeholder="enter trainermobile"
                  isInvalid={!!errors.trainermobile}
                  feedback={errors.trainermobile}
                  inlineFeedback={true}
                  maxLength={10}
                />
              </Col>
              <Col md={4}>
                <Input
                  label="Email ID"
                  type="text"
                  isMandetory={true}
                  name="traineremail"
                  value={form.traineremail}
                  onChange={handelChange}
                  placeholder="enter traineremail"
                  isInvalid={!!errors.traineremail}
                  feedback={errors.traineremail}
                  inlineFeedback={true}
                  maxLength={80}
                />
              </Col>
              <Col md={12}>
                <h6 className="d-block mb-3 ">Coordinator</h6>
              </Col>
              <Col md={4}>
                <Input
                  label="Name"
                  type="text"
                  isMandetory={true}
                  name="coordinatorname"
                  value={form.coordinatorname}
                  onChange={handelChange}
                  placeholder="enter coordinatorname"
                  isInvalid={!!errors.coordinatorname}
                  feedback={errors.coordinatorname}
                  inlineFeedback={true}
                  maxLength={80}
                />
              </Col>
              <Col md={4}>
                <Input
                  label="Mobile No."
                  type="text"
                  isMandetory={true}
                  name="cordinatormobile"
                  value={form.cordinatormobile}
                  onChange={handelChange}
                  placeholder="enter cordinatormobile"
                  isInvalid={!!errors.cordinatormobile}
                  feedback={errors.cordinatormobile}
                  inlineFeedback={true}
                  maxLength={10}
                />
              </Col>
              <Col md={4}>
                <Input
                  label="Email ID"
                  type="text"
                  isMandetory={true}
                  name="cordinatoremail"
                  value={form.cordinatoremail}
                  onChange={handelChange}
                  placeholder="enter cordinatoremail"
                  isInvalid={!!errors.cordinatoremail}
                  feedback={errors.cordinatoremail}
                  inlineFeedback={true}
                  maxLength={80}
                />
              </Col>
            </Row>
            <Row style={{ borderTop: "1px solid #dee2e6", marginTop: '1rem', paddingTop: '0.5rem' }}>
              <Col md={6}>
                <h5 className="d-block mb-1 fw-bold">Stakeholder Information</h5>
              </Col>
              <Col md={6} className="d-flex justify-content-end">
                <Button variant="outline-secondary" title="Reset" type="button" className="px-4" onClick={handelAddStakeholder}>
                  + Add Stakeholder
                </Button>
              </Col>

              <Col md={12}>
                {form?.stakeHolderList.length ? (
                  <Table responsive className='mytable'>
                    <thead>
                      <tr>
                        <th scope="col" className='txt-center'>S.No.</th>
                        <th scope="col" className='txt-center'>Stakeholder Type</th>
                        <th scope="col" className='text-nowrap'>Organization at</th>
                        <th scope="col" className='text-nowrap'>Role</th>
                        <th scope="col" className='text-nowrap'>Name</th>
                        <th scope="col" className='text-nowrap'>Mobile No</th>
                        <th scope="col" className='text-nowrap'>Email Id</th>
                        <th scope="col" className='text-nowrap'>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {form?.stakeHolderList.map((stakeholder, idx) => {
                        console.log("🚀 krishna  ~ stakeholder:", stakeholder);

                        return <tr key={idx}>
                          <td className='txt-center'>{idx + 1}</td>
                          <td className='txt-center'>{stakeholder.holdertype}</td>
                          <td>{stakeholder.organisation}</td>
                          <td>{stakeholder.role}</td>
                          <td>{stakeholder.name}</td>
                          <td>{stakeholder.mobile}</td>
                          <td>{stakeholder.email}</td>
                          <td>{'delete'}</td>
                        </tr>
                      })}
                    </tbody>
                  </Table>
                ) :
                  <div >Stakeholder not added</div>
                }
              </Col>

            </Row>
            {form?.stakeHolderList.length ?
              (<Row>
                <div className="d-flex gap-3 justify-content-end">
                  <Button variant="outline-secondary" title="Reset" type="button" className="px-4" onClick={resetForm}>
                    Reset
                  </Button>

                  <Button type="submit" title="Save" className="save-btn px-5" >
                    Save
                  </Button>

                </div>
              </Row>)
              : null
            }

          </Form>
        </div>
      </Row>
      {/* {showAlert.show &&
        <AlertMassage
          show={showAlert.show}
          type={showAlert.type}
          title={showAlert.title}
          massage={showAlert.msg}
          hideAlert={hideAlert} />
      } */}
      {popupData.show && popupData.type === 'addstakeholder' ?
        <PopupModel
          size='lg'
          showModal={popupData.show}
          handleCloseModal={handleCloseModal}
          title={popupData.title}
          type={popupData.type}
        >
          <Form >
            <Row>
              <Col md={4}>
                <Input
                  label="Stakeholder Type"
                  type="select"
                  name="holdertype"
                  value={stakeHolderinformation.holdertype}
                  onChange={handelChangestakeholder}
                  isInvalid={!!errorStakeholder.holdertype}
                  feedback={errorStakeholder.holdertype}
                  options={stakeHolderType}
                  isMandetory={true}
                  inlineFeedback={true}
                />
              </Col>
              <Col md={4}>
                <Input
                  label="Organization"
                  type="select"
                  name="organisation"
                  value={stakeHolderinformation.organisation}
                  onChange={handelChangestakeholder}
                  isInvalid={!!errorStakeholder.organisation}
                  feedback={errorStakeholder.organisation}
                  options={organization}
                  isMandetory={true}
                  inlineFeedback={true}
                />
              </Col>
              <Col md={4}>
                <Input
                  label="Role"
                  type="select"
                  name="role"
                  value={stakeHolderinformation.role}
                  onChange={handelChangestakeholder}
                  isInvalid={!!errorStakeholder.role}
                  feedback={errorStakeholder.role}
                  options={role}
                  isMandetory={true}
                  inlineFeedback={true}
                />
              </Col>
              <Col md={4}>
                <Input
                  label="Name"
                  type="text"
                  isMandetory={true}
                  name="name"
                  value={stakeHolderinformation.name}
                  onChange={handelChangestakeholder}
                  placeholder="enter name"
                  isInvalid={!!errorStakeholder.name}
                  feedback={errorStakeholder.name}
                  inlineFeedback={true}
                  maxLength={80}
                />
              </Col>
              <Col md={4}>
                <Input
                  label="Email ID"
                  type="text"
                  isMandetory={true}
                  name="email"
                  value={stakeHolderinformation.email}
                  onChange={handelChangestakeholder}
                  placeholder="enter email"
                  isInvalid={!!errorStakeholder.email}
                  feedback={errorStakeholder.email}
                  inlineFeedback={true}
                />
              </Col>
              <Col md={4}>
                <Input
                  label="Mobile Number"
                  type="text"
                  isMandetory={true}
                  name="mobile"
                  value={stakeHolderinformation.mobile}
                  onChange={handelChangestakeholder}
                  placeholder="enter mobile"
                  isInvalid={!!errorStakeholder.mobile}
                  feedback={errorStakeholder.mobile}
                  inlineFeedback={true}
                  maxLength={10}
                />
              </Col>
              <Col md={12} className="d-flex justify-content-end">
                <Button type="submit" title="Proceed" className="save-btn px-5" onClick={handleAddStakeHolder} >
                  Proceed
                </Button>
              </Col>
            </Row>
          </Form>
        </PopupModel> : null
      }
    </Col>
  );
}